// "How did you feel?" after a chat with a person. Not a rating: it's about how
// the person feels, never a score for the other person. Shared with the server.
//
// Warm picks send the other person a short note. "Wish it went better" is only
// counted, and the other person is never told.

export const FEELINGS = [
  { key: 'heard', emoji: '🤍', label: 'Heard', note: 'You helped someone feel heard.' },
  { key: 'lighter', emoji: '🌤️', label: 'A little lighter', note: 'Someone left your chat a little lighter.' },
  { key: 'comforted', emoji: '🫶', label: 'Comforted', note: 'Your chat brought someone comfort.' },
  { key: 'glad', emoji: '😊', label: 'Glad we talked', note: 'Someone is glad they talked with you.' },
  { key: 'better', emoji: '🌧️', label: 'Wish it went better', note: null },
] as const;

export type FeelingKey = typeof FEELINGS[number]['key'];

export const isFeelingKey = (k: unknown): k is FeelingKey => FEELINGS.some(f => f.key === k);
